export default "__VITE_ASSET__Dh389hNH__"